import { LtlAccessorialsFormSection } from '../shipment-form/LtlAccessorialsFormSection'
import { useBookingFormCtx } from './BookingFormProvider'

export const BookingAccessorials = ({ disabled }: { disabled?: boolean }) => {
  const workflow = useBookingFormCtx(s => s.workflow)
  const equipmentAccessorials = useBookingFormCtx(s => s.equipmentAccessorials)
  const toggleEquipmentAccessorial = useBookingFormCtx(
    s => s.actions.toggleEquipmentAccessorial,
  )

  if (workflow !== 'ltl') return null

  return (
    <LtlAccessorialsFormSection
      disabled={disabled}
      value={equipmentAccessorials}
      onChange={toggleEquipmentAccessorial}
    />
  )
}
